import { TranslateService } from "./../../shared/translate/translate.service";
import { InstanceService } from "./../../instance/models/instance.service";
import { InstanceModel } from "./../../instance/models/instance.model";
import { FlatPickrModel } from "../../plugins/flatpickr/flatpickr.model";
import {
  ApplicationRouteURL,
  WeGoConfig,
  IKeyValueInterface,
  RoleLevel,
  QuestionType,
  Permission
} from "./../../shared/config";
import { AuthService } from "./../../shared/models/auth.service";
import { Component, OnInit, Output, EventEmitter, Input } from "@angular/core";
import { DropdownModel } from "../../report/models/report-filter.model";
import { PrePostQuestionSearchModel } from "../models/pre-post-question-search.model";
import { VehicleMappingModel } from "../../vehicle/models/vehicle.model";
import { OrganizationDriverMappingModel } from "../../organizationdriver/models/organization-driver.model";
import { PrePostTripQuestionOverviewService } from "../models/pre-post-question-overview.service";
import { CompanyService } from "../../company/models/company.service";

const SlimSelect1 = require("slim-select");
const moment = require("moment");

@Component({
  selector: "wego-pre-post-search-filter",
  template: require('../views/pre-post-question-search.component.html'),
  providers: [
    InstanceService,
    PrePostTripQuestionOverviewService,
    CompanyService
  ],
  styles: [
    `
    .search-icon {
        color:#2ba2aa;
    }
    .reset-icon {
        color:#DD9933;
    }
    .export-icon {
        color:#01A2D9;
    }
    .delete-icon {
        color:#f00;
    }
    .cancel-icon {
        color:#f00;
    }
    .add-icon {
        color:#080;
    }
    .nopad-left{
      padding-left: 0px;
    }
    `
  ]
})
export class PrePostQuestionSearchComponent implements OnInit {
  permission: any;
  questionType: { Key: string; Value: number }[];
  questionNameList: any;
  LblQuestion: string;
  LblType: string;
  LblSelect: string;
  questionTypeSelect: any;
  QuestionTypeAll: { Key: string; Value: number }[];
  QuestionType: { Key: string; Value: number }[];
  searchSVGName: string;
  companyName: string;
  companyList: DropdownModel[];
  searchLicenceTag: string;
  searchDriverName: string;
  isValidSearch: boolean;
  isLoader: boolean;
  apiErrorMsg: string;
  model: PrePostQuestionSearchModel;
  pageName: string;
  instanceList: DropdownModel[];
  roleLevel = RoleLevel;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  vehicleList: DropdownModel[];

  @Output("ResetValidSearch") resetValidSearch = new EventEmitter();
  @Output("OnAdvancedReset") onAdvancedReset = new EventEmitter();
  @Output("OnExport") onExport = new EventEmitter();
  @Output("ShowCancelModal") showCancelModal = new EventEmitter();
  @Output("OnAdvancedSearch") onAdvancedSearch = new EventEmitter();
  @Output("OnPagingChange") onPagingChange = new EventEmitter();
  @Input("IsExported") isExported: boolean = true;
  @Input("SearchTerm") searchTerm: string = "";
  @Input("itemPerPageList") itemPerPageList: any;
  @Input("ItemPerPage") itemPerPage: any;
  @Input("ErrorModel") errorModel: IKeyValueInterface[];

  public get isInstanceSelected(): boolean {
    return !!this.model.instanceHashId;
  }

  public get isCompanySelected(): boolean {
    return !!this.model.companyHashIdList;
  }

  constructor(
    private instanceService: InstanceService,
    private companyService: CompanyService,
    private authService: AuthService,
    private translate: TranslateService,
    private prePostTripQuestionOverviewService: PrePostTripQuestionOverviewService
  ) {}

  ngOnInit() {
    this.model = new PrePostQuestionSearchModel();
    this.QuestionTypeAll = [
      {
        Key: "PREBEFORE",
        Value: 1
      },
      {
        Key: "PREAFTER",
        Value: 2
      },
      {
        Key: "POST",
        Value: 3
      },
      {
        Key: "CUSTOM",
        Value: 4
      }
    ];

    this.questionType = this.QuestionTypeAll;
    this.model.questionTypeList = this.questionType.map(x => x.Value);
    this.pageName = "Pre-Post-Question";
    this.permission = Permission.PR_PRE_POST_TRIP_QUESTIONS

    this.LblSelect = this.translate.instant("LblSelect");
    this.LblType = this.translate.instant("LblType");
    this.LblQuestion = this.translate.instant("LblQuestion");
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.itemPerPageList = WeGoConfig.GRID_PAGGING;
    this.GetAllInstanceList();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.dateFormat = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  GetAllInstanceList() {
    this.instanceService.GetDropdownInstanceList(this.pageName).subscribe(
      res => {
        this.instanceList = res.data;
        if (this.instanceList && this.instanceList.length > 0) {
          if (!this.model.instanceHashId && this.instanceList.length == 1) {
            this.model.instanceHashId = this.instanceList[0].keyHash;
          }
          this.OnInstanceChange();
        }
      },
      error => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
      }
    );
  }

  public OnInstanceChange() {
    this.isLoader = true;
    this.ResetValidSearch();
    this.vehicleList = null;
    this.companyList = [];
    this.questionNameList = [];
    this.GetAllQuestionNameList();
  }

  public OnFromDateChange() {
    //this.ResetValidSearch();
  }

  public OnToDateChange() {
    //this.ResetValidSearch();
  }

  public get vehicleMappingModel(): VehicleMappingModel {
    let vehicleMapping: VehicleMappingModel = new VehicleMappingModel();
    vehicleMapping.companyHashId = this.model.companyHashId;
    vehicleMapping.instanceHashId = this.model.instanceHashId;
    return vehicleMapping;
  }

  public get organizationDriverModel(): OrganizationDriverMappingModel {
    let organizationDriverMapping: OrganizationDriverMappingModel = new OrganizationDriverMappingModel();
    organizationDriverMapping.companyHashId = this.model.companyHashId;
    organizationDriverMapping.instanceHashId = this.model.instanceHashId;
    return organizationDriverMapping;
  }

  GetAllQuestionNameList() {
    this.prePostTripQuestionOverviewService
      .GetDrowdownQuestionName(this.model)
      .subscribe(
        res => {
          this.questionNameList = res.data;
          if (this.questionNameList && this.questionNameList.length > 0) {
            if (
              !this.model.questionHashId &&
              this.questionNameList.length == 1
            ) {
              this.model.questionHashId = this.questionNameList[0].keyHash;
            }
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public ResetValidSearch() {
    this.clearDriverList();
    this.clearVehicleList();
    this.clearCompanyList();
    this.ClearSvg();
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  public SuccessSelectDriverModal($event: any) {
    this.model.searchDriverNameList = $event.DriverName;
    this.searchDriverName = this.model.searchDriverNameList.join();
    this.model.driverHashIdList = $event.DriverHashId;
    this.GetAllQuestionNameList();
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  public SuccessSelectVehicleModal($event: any) {
    this.model.searchLicenceTagList = $event.LicenceTag;
    this.searchLicenceTag = this.model.searchLicenceTagList.join();
    this.model.vehicleHashIdList = $event.VehicleMasterHashID;
    this.GetAllQuestionNameList();
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  public SuccessSelectCompanyModal($event: any) {
    this.model.searchCompanyList = $event.CompanyName;
    this.companyName = this.model.searchCompanyList.join();
    this.model.companyHashIdList = $event.CompanyHashId;
    this.GetAllQuestionNameList();
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  public SuccessSelectSvgModal($event: any) {
    this.model.searchSVGNameList = $event.SvgName;
    this.searchSVGName = this.model.searchSVGNameList.join();
    this.model.sharedVehicleGroupHashIdList = $event.SvgMasterHashID;
    this.GetAllQuestionNameList();
  }

  public clearCompanyList() {
    this.model.searchCompanyList = [];
    this.companyName = "";
    this.model.companyHashIdList = [];
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  public clearDriverList() {
    this.model.searchDriverNameList = [];
    this.searchDriverName = "";
    this.model.driverHashIdList = [];
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  public clearVehicleList() {
    this.model.searchLicenceTagList = [];
    this.searchLicenceTag = "";
    this.model.vehicleHashIdList = [];
    this.isValidSearch = false;
    this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
  }

  public ClearSvg() {
    this.model.searchSVGNameList = [];
    this.searchSVGName = "";
    this.model.sharedVehicleGroupHashId = "";
    this.model.sharedVehicleGroupHashIdList = [];
  }

  ngAfterViewInit() {
    this.questionTypeSelect = new SlimSelect1({
      select: "#questionType",
      placeholder: this.LblSelect + " " + this.LblQuestion + " " + this.LblType,
      showSearch: false,
      onChange: (info: any) => {
        this.model.questionTypeList = info.map((x: any) => x.value);
      }
    });

    this.questionTypeSelect.set(this.model.questionTypeList);
  }

  OnAdvancedSearch() {
    this.onAdvancedSearch.emit({ prePostSearchFilterModel: this.model });
  }

  OnExport($event: any) {
    this.onExport.emit($event);
  }

  OnAdvancedReset($event: any) {
    this.companyName = "";
    this.searchSVGName = "";
    this.searchLicenceTag = "";
    this.searchDriverName = "";
    this.model = new PrePostQuestionSearchModel();
    this.model.questionTypeList = this.questionType.map(x => x.Value);
    this.questionTypeSelect.set(this.model.questionTypeList);
    this.onAdvancedReset.emit({
      prePostSearchFilterModel: this.model,
      isReset: true
    });
    this.GetAllInstanceList();
  }

  OnPagingChange($event: any) {
    this.onPagingChange.emit({ itemPerPage: $event });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/pre-post-trip-question-overview/components/pre-post-question-search.component.ts